import { render, staticRenderFns } from "./EditInput.vue?vue&type=template&id=bf01a53a&lang=pug&"
import script from "./EditInput.vue?vue&type=script&lang=ts&"
export * from "./EditInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports